const brand = process.env.BRAND === `bt` ? `b` : `u`;

export const WebProVpn = {
    webWin: `https://store.bittorrent.com/${brand}_w_pv_w`,
    webMac: `https://store.bittorrent.com/${brand}_w_pv_m`,
};
export const WebPro = {
    webWin: `https://store.bittorrent.com/${brand}_w_p_w`,
    webMac: `https://store.bittorrent.com/${brand}_w_p_m`,
};
// export const WebAf = {
//     webWin: `https://store.bittorrent.com/${brand}_w_af_w`,
//     webMac: `https://store.bittorrent.com/${brand}_w_af_m`,
// };

export const WebAfUT = {
    webWin: `https://store.payproglobal.com/checkout?products[1][id]=100721`,
    webMac: `https://store.payproglobal.com/checkout?products[1][id]=90510`,
};

// WebAfBT is for BT brand only
export const WebAfBT = {
    webWin: `https://store.payproglobal.com/checkout?products[1][id]=120537`,
    webMac: `https://store.payproglobal.com/checkout?products[1][id]=120538`,
}